import { SelectPlanButtonProps, SelectPlanButtonStateProps } from '../../types/components/pricing/SelectPlanButton';
import { ApplicationState } from '../../types/state/storeTypes';
import { SubscriptionDetail } from '../../types/api/SubscriptionTypes';

import { MainLinkButton } from '../styled/buttons/MainLinkButton';
import FreeSubscriptionConfirmation from './FreeSubscriptionConfirmation';

import { connect, useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import { useState } from 'react';

import { AUTH_ACTIONS, ONBOARDING_MODAL_ACTIONS } from '../../constants/actions';
const { AUTH_SHOW_SIGN_UP } = AUTH_ACTIONS;
const { OPEN_ONBOARDING_MODAL, SET_ENTERPRISE_FLOW } = ONBOARDING_MODAL_ACTIONS
import { showUpgradeSubscriptionModal } from '../../state/actions/subscriptionUpgradeActions';

export const disabledButtonStyle = '!bg-[#FFFFFF1A] !text-[#7F898D] cursor-not-allowed';

export const bigButtonStyle = '!w-full';
export const smallButtonStyle = '!text-[12px] normal-case font-[inter] p-0 !h-[40px] !w-[100px] xl:!w-[160px]';

export const freePlanButtonVariant = 'outlined';
export const paidPlanButtonVariant = 'green';

export const buttonLabels = {
  getStarted: 'Get Started',
  contactSales: 'Get Instant Pricing',
  currentPlan: 'Current Plan',
  subscribe: 'Select Plan',
  upgrade: 'Upgrade',
  downgrade: 'Downgrade',
};

import subscriptionUpgradeHelpers from '../../helpers/subscriptionUpgradeHelpers';
import YesNoPromptDialog from '../shared/YesNoPromptDialog';
import LicenseConfirmationMinimalFlowModal from '../license-confirmation-modals/LicenseConfirmationMinimalFlowModal';

const SelectPlanButton: React.FC<SelectPlanButtonProps> = ({
  freePlan,
  selectedPlanVariant,
  licenseId,
  displayContactSalesUI,
  subscription,
  uiSize = 'big',
  user,
}) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const buttonVariant = freePlan ? freePlanButtonVariant : paidPlanButtonVariant;
  const { isUpgradeOrDowngrade } = subscriptionUpgradeHelpers;
  const [showYesNoPromptDialog, setshowYesNoPromptDialog] = useState<boolean>(false);
  const [freeSubscriptionConfirmationOpen, setFreeSubscriptionConfirmationOpen] = useState<boolean>(false);
  const [isMinimalFlowOpen, setIsMinimalFlowOpen] = useState<boolean>(false)

  const isCurrentPlan = (): boolean =>
    !!selectedPlanVariant &&
    subscription?.plan_variant?.group_id === selectedPlanVariant?.group_id;

  const determineLicenseName = () => {
    switch (user.min_license_id) {
      case 1:
        return 'Individual'
      case 2:
        return 'Startup'
      case 3:
        return 'Enterprise'
      case 4:
        return 'Enterprise'
      case 5:
        return 'Enterprise'
      case 6:
        return 'Enterprise'
      default:
        return "N/A"

    }

  }

  const clickHandler = () => {
    if (isCurrentPlan()) return;
    if (displayContactSalesUI) {
      (!!user?.min_license_id || !!user?.team?.licensee_profile) && setshowYesNoPromptDialog(true)
      dispatch({type: OPEN_ONBOARDING_MODAL })
      dispatch({ type: SET_ENTERPRISE_FLOW })
      return;
    }
    if (freePlan) {
      if (user?.token) {
        setFreeSubscriptionConfirmationOpen(true);
        return;
      }
      dispatch({ type: AUTH_SHOW_SIGN_UP });
      return
    }
    if (!subscription && !freePlan) {
      router.push(`/checkout/subscribe/${selectedPlanVariant?.id}?license_id=${licenseId}`);
      return;
    }
    dispatch(showUpgradeSubscriptionModal(selectedPlanVariant.id, licenseId));
  }

  const getButtonStateStyle = (): string => {
    return isCurrentPlan() ?
           disabledButtonStyle :
           '';
  }

  const getButtonSizeStyle = (): string => {
    switch (uiSize) {
      case 'small':
        return smallButtonStyle;
      case 'big':
      default:
        return bigButtonStyle;
    }
  }

  const getButtonText = (): string => {
    if (freePlan) return buttonLabels.getStarted;
    if (displayContactSalesUI && !router.asPath.includes('/enterprise?')) return buttonLabels.contactSales;
    if (isCurrentPlan()) return buttonLabels.currentPlan;
    if (
      !subscription ||
      subscription?.license?.id < licenseId
    ) return buttonLabels.subscribe;
    if (!selectedPlanVariant) return '';
    const _isUpgradeOrDowngrade = isUpgradeOrDowngrade(selectedPlanVariant, { id: licenseId }, subscription);
    switch (_isUpgradeOrDowngrade) {
      case 'upgrade':
        return buttonLabels.upgrade;
      case 'downgrade':
        return buttonLabels.downgrade;
      case false:
      default:
        return '';
    }
  }

  return (
    <>
      <MainLinkButton
        variant={buttonVariant}
        className={`${getButtonStateStyle()} ${getButtonSizeStyle()} `}
        onClick={clickHandler}
        testId="select-plan-button"
      >
        {getButtonText()}
      </MainLinkButton>
      {freeSubscriptionConfirmationOpen && (
        <FreeSubscriptionConfirmation user={user} visible={freeSubscriptionConfirmationOpen} setVisible={setFreeSubscriptionConfirmationOpen} />
      )}

      <YesNoPromptDialog
        dialogOpen={showYesNoPromptDialog}
        onResult={(result) => {
          setshowYesNoPromptDialog(false);
          if (result) {
            setIsMinimalFlowOpen(true)
          }
        }}
        onDialogClosed={() => setshowYesNoPromptDialog(false)}
      >Your current assigned license is <span className='font-extrabold'>{determineLicenseName()}</span>. Proceeding will reset your assigned license to Enterprise. Are you sure you want to continue?</YesNoPromptDialog>

      <LicenseConfirmationMinimalFlowModal isOpen={isMinimalFlowOpen} setIsOpen={setIsMinimalFlowOpen} />
    </>
  );
};

const mapStateToProps = (state: ApplicationState): SelectPlanButtonStateProps => ({
  subscription: state.auth.subscription as SubscriptionDetail,
  user: state.auth.user
});

export default connect(mapStateToProps)(SelectPlanButton);